import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import constraintTypeModel from "src/models/constraintType"
import collection from "src/hocs/collection"

export default config =>
  compose(
    collection({
      engine: entity,
      to: `constraintTypes`,
      model: constraintTypeModel,
      query: {
        limit: -1,
      },
      ...config,
    }),
  )
